export default {
  name: "ColorPickerButton",
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: Boolean
  },
  data: () => ({ showColorPicker: false, color: null }),
  computed: {
    cColor: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.isHexaColor(value)) {
          // Remove Alpha Channel; No option in v-color-picker
          value = value.substr(0, 7);
        }
        this.color = value;
      }
    }
  },
  methods: {
    isHexaColor(str) {
      return str.match(/#[a-zA-Z0-9]{8}/);
    },
    toggleShowColorPicker() {
      if (this.disabled) {
        return;
      }
      this.showColorPicker = !this.showColorPicker;
    }
  },
  watch: {
    color() {
      this.$emit("update", this.color);
    }
  }
};
